
const getters = {
  schedulingEnabledStoreIds() {
    const stores = window.SP.Scenario.Company.getStores() || []
    return new Set(
      stores
        .filter(s => s.isModuleEnabled('scheduling'))
        .map(s => s.id)
    )
  },
}

export default getters
